<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="사업장명(필수)"
      :options="[
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태(필수)', value: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>

    <!-- 점검 대상 -->
    <table-target-equipment-inspection
      class="mt-5"
      :list="form.targetInspectionList"
      @updateList="updateInspectionList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-target-equipment-inspection>

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :isNote="true"
      :title="inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import TableTargetEquipmentInspection from "@/components/TableTargetEquipmentInspection";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    TableTargetEquipmentInspection,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        '점검일' : { required },
        '재해형태': { required }
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        // const keys = Object.keys(this.form);
        // for (const key of keys) {
        //   if ((key === "inspectList" || key === "photoList") && !value[key]) {
        //     // Empty
        //   } else {
        //     this.form[key] = value[key];
        //   }
        // }
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          작업장합동점검_사업장명: [],
          작업장합동점검_점검대상: [],
        };

        value.summary["작업장합동점검_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        for (const data of this.form.targetInspectionList) {
          value.summary["작업장합동점검_점검대상"].push({
            [data.target]: 1,
          });
        }

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "작업장 합동점검",
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",

        inputD_1: {},
        inputD_2: "",
        inputD_3: {},
        inputD_4: "",
        inputD_5: {},
        inputD_6: "",
        inputD_7: {},
        inputD_8: "",

        photoList: [],
        fileList: [],
        equipmentList: [{}],
        targetInspectionList: [{}],
        inspectList: [
          {
            id: 1,
            label: "안전관리자 지정 여부",
            is_checked: "",
            title: "안전보건 관리조직 및 교육",
            note: ''
          },
          {
            id: 2,
            label: "보건관리자 지정 여부",
            is_checked: "",
            title: "안전보건 관리조직 및 교육",
            note: ''
          },
          {
            id: 3,
            label: "안전보건교육 실시 여부",
            is_checked: "",
            title: "안전보건 관리조직 및 교육",
            note: ''
          },
          {
            id: 4,
            label: "교육결과 기록보존상태",
            is_checked: "",
            title: "안전보건 관리조직 및 교육",
            note: ''
          },
          {
            id: 5,
            label: "안전관리비 적정계상 여부",
            is_checked: "",
            title: "산업안전 보건관리비",
            note: ''
          },
          {
            id: 6,
            label: "안전관리비 집행실태(타목적, 용도외 사용 등)",
            is_checked: "",
            title: "산업안전 보건관리비",
            note: ''
          },
          {
            id: 7,
            label: "항목별 적정비율 집행 여부",
            is_checked: "",
            title: "산업안전 보건관리비",
            note: ''
          },
          {
            id: 8,
            label: "보호구 적격품(검정) 구입 여부",
            is_checked: "",
            title: "개인보호구 지급",
            note: ''
          },
          {
            id: 9,
            label: "개인보호구 지급 여부",
            is_checked: "",
            title: "개인보호구 지급",
            note: ''
          },
          {
            id: 10,
            label:
              "개인보호구 착용 여부 (방진마스크, 귀마개, 안전모, 안전대, 안전화 등)",
            is_checked: "",
            title: "개인보호구 지급",
            note: ''
          },
          {
            id: 11,
            label: "유해･위험방지계획서 제출 및 이행 여부 등",
            is_checked: "",
            title: "기타 안전대책",
            note: ''
          },
          {
            id: 12,
            label: "위험물(인화성 물질 등) 관리 상태",
            is_checked: "",
            title: "기타 안전대책",
            note: ''
          },
          {
            id: 13,
            label: "화재예방 대책(소화기 비치 비상 연락망 편성 등)",
            is_checked: "",
            title: "기타 안전대책",
            note: ''
          },
          {
            id: 14,
            label: "위험,주의,경고 등 표지판 설치 상태",
            is_checked: "",
            title: "기타 안전대책",
            note: ''
          },
          {
            id: 15,
            label: "작업장 내 자재의 정리 정돈 및 안전통로 확보 상태",
            is_checked: "",
            title: "기타 안전대책",
            note: ''
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateInspectionList(list) {
      this.form.targetInspectionList = list;
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) {
          alert("사업장명을 반드시 입력해야 합니다");
        }
        else if (!this.$v.form.stdInfo['점검일'].required) {
          alert("점검일을 반드시 입력해야 합니다");
        }
        else if (!this.$v.form.stdInfo['재해형태'].required) {
          alert("재해형태를 반드시 입력해야 합니다");
        }

        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
